import React from 'react'
import { components } from 'cng-web-lib'

import TmpComponentApiUrls from 'src/apiUrls/TmpComponentApiUrls'
import FormProperties from './FormProperties'

const {
  form: {
    CngAddForm
  }
} = components

function AddPageDialog({ history, showNotification, onPostSubmitSuccess }) {
  return (

    <CngAddForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      shouldDisableEnterToSubmit
      showNotification={showNotification}
      history={history}
      bodySection={
        < FormProperties.Fields
          disabled={false}
          showNotification={showNotification}
          mode={"add"}
        />
      }
      buttonText="Save"
      formikProps={FormProperties.formikProps}
      toClientDataFormat={FormProperties.toClientDataFormat}
      toServerDataFormat={FormProperties.toServerDataFormat}

      create={{
        url: TmpComponentApiUrls.CREATE,
        onPostSubmitSuccess: onPostSubmitSuccess
      }}
      innerForm={true}
    />
  )

}


export default AddPageDialog
